module.exports = __webpack_public_path__ + "static/feature_image-4ee07bc3efaae33c61492a32973a37b6.svg";